<script>
import simplebar from "simplebar-vue";
import SideNavPublic from "./side-nav-public";

export default {
  components: { simplebar, SideNavPublic },
  props: {
    isCondensed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      settings: { minScrollbarLength: 60 },
    };
  },
};
</script>

<template>
  <div class="vertical-menu">
    <simplebar v-if="!isCondensed" :settings="settings" class="h-100">
      <SideNavPublic />
    </simplebar>
    <simplebar v-else class="h-100">
      <SideNavPublic />
    </simplebar>
  </div>
</template>
